import { render } from "./ModalQnaProductText.vue?vue&type=template&id=32541bfd&scoped=true"
import script from "./ModalQnaProductText.vue?vue&type=script&lang=js"
export * from "./ModalQnaProductText.vue?vue&type=script&lang=js"

import "./ModalQnaProductText.vue?vue&type=style&index=0&id=32541bfd&scoped=true&lang=css"

import exportComponent from "/home/hosting_users/shoplus/custom/survey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32541bfd"]])

export default __exports__